export default __webpack_public_path__ + "static/media/checkmark.17da7b0b.svg";